import { useFormikContext } from "formik";
import { useTranslation } from "gatsby-plugin-react-i18next";
import _range from "lodash/range";
import React, { useState } from "react";
var InputOTP = function InputOTP(props) {
    var _useTranslation = useTranslation(), t = _useTranslation.t, i18n = _useTranslation.i18n;
    var formik = useFormikContext();
    var defaultProps = { label: i18n.exists(props.name.toUpperCase() + ".LABEL") ? t(props.name.toUpperCase() + ".LABEL") : props.name, required: true, disabled: false, value: formik.values[props.name] ? formik.values[props.name] : [null, null, null, null, null, null], error: formik.errors[props.name] ? formik.errors[props.name] : "", touched: formik.touched[props.name] ? formik.touched[props.name] : false, isSubmitting: formik.isSubmitting ? formik.isSubmitting : false };
    props = Object.assign({}, defaultProps, props);
    var inputRefFull = React.useRef();
    var inputRef = [React.useRef(), React.useRef(), React.useRef(), React.useRef(), React.useRef(), React.useRef()];
    var hasError = (props.touched || props.isSubmitting) && props.error && props.error.trim() !== "";
    var _useState = useState(props.value), fullValue = _useState[0], setFullValue = _useState[1];
    var getNewValue = function getNewValue(value, index) { var newFullValue = fullValue; newFullValue[index] = value; return newFullValue; };
    var autoTap = function autoTap(index) {
        if (index == 5) {
            return;
        }
        inputRef[index + 1].current.focus();
        inputRef[index + 1].current.value = ""; //  setFullValue(getNewValue("", index + 1));
    };
    var clearInput = function clearInput(index) { var _Object$assign; setFullValue(getNewValue("", index)); formik.setValues(Object.assign({}, formik.values, (_Object$assign = {}, _Object$assign[props.name] = fullValue, _Object$assign))); };
    var updateInput = function updateInput(value, index, e) {
        //   inputRef[index].current.value = "";
        //   if (index > 0) {
        //     inputRef[index - 1].current.focus();
        //   }
        //   return;
        // } else {
        if (e.key === "Backspace") {
            inputRef[index].current.value = "";
            if (index > 0) {
                inputRef[index - 1].current.focus(); // e.preventDefault();
                // updateInput(e.target.value, index, e);
            }
            return;
        }
        else {
            var _Object$assign2;
            setFullValue(getNewValue(value, index));
            formik.setValues(Object.assign({}, formik.values, (_Object$assign2 = {}, _Object$assign2[props.name] = fullValue, _Object$assign2)));
        } // }
    };
    var eventhandler = function eventhandler(e, index) {
        if (e.key === "Backspace") {
            inputRef[index].current.value = "";
            if (index > 0) {
                inputRef[index - 1].current.focus();
                updateInput(e.target.value, index, e);
            }
            return;
        }
        autoTap(index); // e.preventDefault();
    };
    return /*#__PURE__*/ React.createElement("div", { className: "w-full inline-flex flex-col space-y-1 items-center justify-center mb-3 " }, /*#__PURE__*/ React.createElement("input", { ref: inputRefFull, name: props.name, type: "tel", value: props.value, className: "hidden", onChange: function onChange() { } }), /*#__PURE__*/ React.createElement("div", { className: "flex space-x-1.5" }, _range(6).map(function (item, index) {
        return /*#__PURE__*/ React.createElement("div", { key: index, className: "w-8 xs:w-11 h-14 rounded-xl flex items-center justify-center border transition-all duration-500" + (hasError ? "border-red-60" : "text-b-5  focus-within:border-blue-70 flash-border-blue border-transparent") + " \n            " + (props.disabled ? "bg-disabled-1" : "bg-input-1") + " \n            " + (fullValue[index] ? "border-blue-70" : "") + " \n          " }, /*#__PURE__*/ React.createElement("input", { ref: inputRef[index], name: props.name + index, type: "tel", value: fullValue[index], className: "w-full h-full text-b-2 text-center p-2\n              " + (props.disabled ? "bg-disabled-1" : "bg-transparent"), onChange: function onChange(e) { updateInput(e.target.value, index, e); }, onClick: function onClick() { clearInput(index); }, maxLength: 1, onKeyUp: function onKeyUp(e) { return eventhandler(e, index); } // onBlur={}
            ,
            disabled: props.disabled ? true : false }));
    })), hasError && /*#__PURE__*/ React.createElement("div", { className: "inline-flex px-4 items-center justify-end animate-fade-in-down" }, /*#__PURE__*/ React.createElement("p", { className: "text-xs leading-none text-red-60" }, props.error)));
};
export default InputOTP;
